<search-icon-svg />
<div class="search">
  <div class="search-field">
    <span 
      class="material-symbols-outlined" 
      [ngClass]="{'loader-with-search-icon': initialSearchLoading()}" 
      [style.top]="searchIconMarginTop()" 
      translate="no">
      search
    </span>
    
    <input
      #search
      type="search"
      class="search-input"
      [placeholder]="placeholder()"
      [attr.aria-label]="placeholder() || 'Search'"
      [matAutocomplete]="auto"
      (input)="query.set($any($event.target).value)">
  </div>

  @if (query().length > 0 && query().length < minSearchLength) {
    <div class="search-result-initial-info">
      <span class="material-symbols-outlined search-result-initial-info-icon" translate="no">info</span>
      <div class="search-result-initial-info-text">
        Please type at least {{ minSearchLength }} characters
      </div>
    </div>
  }

  <mat-autocomplete 
    class="search-results" 
    #auto="matAutocomplete"
    (opened)="syncPanelWidthToInput()"
    (optionSelected)="onSearchOptionSelected($event)">
    
    @if (query().length >= minSearchLength) {
      
      @if (initialSearchLoading()) {
        <mat-option disabled class="search-searching-option">
          <div class="search-searching">
            <mat-spinner class="search-searching-spinner" [diameter]="20" [strokeWidth]="2"></mat-spinner>
            <span class="search-searching-text">Searching...</span>
          </div>
        </mat-option>
      } 
      
      @else if (searchOptions().length > 0) {
        @for (option of searchOptions(); track option.objectID || option.id) {
          <mat-option [value]="option">
            <div class="search-option-body search-option-result-item">
              <svg class="search-option-result-item-icon">
                <use xlink:href="#searchIcon"></use>
              </svg>
              <div class="search-option-fullitem-info-div">
                @if (isUserSearch()) {
                  <div class="search-option-fullitem-info-name-div" [innerHTML]="findHtml(option) | safeHtml"></div>
                  <div class="search-option-fullitem-info-email-div" [innerHTML]="(option?._highlightResult?.email?.value || option?.email || '') | safeHtml"></div>
                } @else {
                  <div class="search-option-fullitem-info-name-div" [innerHTML]="findHtml(option) | safeHtml"></div>
                }
              </div>
            </div>
          </mat-option>
        }
      } 
      
      @else if (noMatchingRecord()) {
        <mat-option disabled class="search-empty-result-option">
          <div class="search-empty-result">
            <div class="search-empty-result-text">No matching results found</div>
          </div>
        </mat-option>
      }
    }
  </mat-autocomplete>
</div>